<script>
    export default {
        data() {
            return {
                minHeight: 0,
            }
        },
        methods: {
            openMenu() {
                this.minHeight = this.$refs.logo.$el.clientHeight;

                let maxHeight = 0;
                jQuery('.menu-item-list').each((index, element) => {
                    maxHeight = Math.max(jQuery(element).height(), maxHeight);
                });

                // we add 65 to fixed height of menu and 20 for some nice extra padding
                this.minHeight = Math.max(this.minHeight, maxHeight + 65 + 20);
            },
            closeMenu() {
                this.minHeight = 0;
            }
        },
        mounted() {
            //
        },
    }
</script>
